import type { HubCapsule } from 'aws-amplify/utils';

import { AppStore } from '@/stores';
import { AuthStates } from '@/types/types';

export interface SignInOptions {
    authState?: string;
    username?: string;
    isFederated?: boolean;
    password?: string;
}

// TODO: refactor all these any to real types; remove invalid props
export interface IAuthenticatorChildrenProps {
    signInCalls?: (signInCall: () => Promise<any>, nameSpace: string, options: SignInOptions ) => Promise<boolean>;
    nameSpace?: string
    authState?: AuthStates;
    appStore?: AppStore,
    gdrive?: boolean,
    box?: boolean,
}

export type AppAuthenticatorProps = Omit<IAuthenticatorChildrenProps, 'authState'>;

/* eslint-disable camelcase */
/** Amplify v6 auth Hub event names (renamed from v5). */
export enum CognitoAuthEvents {
    signedIn = 'signedIn',
    signedOut = 'signedOut',
    tokenRefresh = 'tokenRefresh',
    tokenRefresh_failure = 'tokenRefresh_failure',
    signInWithRedirect = 'signInWithRedirect',
    signInWithRedirect_failure = 'signInWithRedirect_failure',
    customOAuthState = 'customOAuthState',
}

/** v6 Hub payload for the `auth` channel. */
export type AuthHubCapsule = HubCapsule<'auth', { event: string; data?: unknown }>;
export type AuthHubPayload = AuthHubCapsule['payload'];
